import { useState, useEffect } from 'react'
import { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { RouterScrollProvider } from '@moxy/next-router-scroll'
import { createGlobalStyle, ThemeProvider as ScThemeProvider } from 'styled-components'
// import { ThemeProvider } from 'next-themes'
import { Hydrate, QueryClient, QueryClientProvider } from 'react-query'
import * as ga from '../lib/ga'
import Toaster from '../components/Toaster'
import { ReactQueryDevtools } from 'react-query/devtools'
import Error from 'components/Error'
import useLogging from 'hooks/useLogger'
import useBypassTimer from 'hooks/useBypassTimer'

import '../styles/globals.css'

const theme = {}

const GlobalStyle = createGlobalStyle``

function MyApp({ Component, pageProps }: AppProps) {
  const [queryClient] = useState(() => new QueryClient())
  const router = useRouter()

  const { DebugDialog } = useLogging({ shouldPrompt: router.query.debug !== undefined })

  // Countdown logic start
  useBypassTimer({ bypassParam: router.query.test000r as string })
  // Countdown logic end

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      ga.pageview(url)
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  return (
    <>
      <GlobalStyle />
      <Toaster />
      <DebugDialog />
      <ScThemeProvider theme={theme}>
        {/* <ThemeProvider attribute="class"> */}
        <QueryClientProvider client={queryClient}>
          <Hydrate state={pageProps.dehydratedState}>
            <Error>
              <RouterScrollProvider>
                <Component {...pageProps} />
              </RouterScrollProvider>
            </Error>
          </Hydrate>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
        {/* </ThemeProvider> */}
      </ScThemeProvider>
    </>
  )
}

export default MyApp
